import React, { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { setAuthorization } from '../helpers/api_helper';
import { useDispatch } from 'react-redux';

import { useProfile } from '../Components/Hooks/UserHooks';

import { logoutUserSuccess } from 'slices/auth/login/reducer';
import { getPrivileges } from 'common/IsAuthorized';

const SHOW_HOME_PAGE = process.env.REACT_APP_SHOW_HOME_PAGE === 'true';
const UNAUTHENTICATED_REDIRECT = SHOW_HOME_PAGE ? '/home' : '/login';

const AuthProtected = (props: any) => {
    const dispatch: any = useDispatch();
    const { userProfile, loading, token } = useProfile();

    const privileges = getPrivileges();

    useEffect(() => {
        if (userProfile && !loading && token) {
            setAuthorization(token);
        } else if (!userProfile && loading && !token) {
            localStorage.clear();
            sessionStorage.clear();
            dispatch(logoutUserSuccess(true));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [token, userProfile, loading, dispatch]);

    // Helper function to check for privilege match
    const hasAnyPrivilege = (privileges: any, routeItem: any): boolean => {
        const privilegeKeys = ['view', 'create', 'edit', 'delete', 'download', 'isActive'];
        if (routeItem.multiRole === 'CHOOSE_ROLE') {
            return true;
        }
        return privilegeKeys.some((key) => {
            const value = routeItem?.[key];
            return value && privileges?.includes(value?.toUpperCase());
        });
    };

    // Usage
    const privCheck = hasAnyPrivilege(privileges, props?.route);

    const navigateObj: { pathname: string; state: { from: string } } = { pathname: UNAUTHENTICATED_REDIRECT, state: { from: props.location } };
    const loginNavigate: { pathname: string; state: { from: string } } = { pathname: UNAUTHENTICATED_REDIRECT, state: { from: props.location } };

    if (!privCheck) {
        /*
         * if (token) {
         *     return <Navigate to="/auth-404-cover" />;
         * } else {
         *     // Clear storage and navigate to login if no token
         *     localStorage.clear();
         *     sessionStorage.clear();
         *     return <Navigate to={navigateObj} />;
         * }
         */

        localStorage.clear();
        sessionStorage.clear();
        return <Navigate to={navigateObj} />;
    } else if (!userProfile && userProfile.roles[0].role !== 'GUEST') {
        if (loading && !token) {
            localStorage.clear();
            sessionStorage.clear();
            return <Navigate to={loginNavigate} />;
        }
    }
    return <>{props.children}</>;
};

export default AuthProtected;
